import { Button } from "@moneyforward/mfx_biz_react_components";

type Props = {
  onClick: () => void;
  loading: boolean;
  userIsAdminUsersAtMikatanoID?: boolean;
};

export const ChangeToMemberButton = ({
  onClick,
  loading,
  userIsAdminUsersAtMikatanoID,
}: Props) => {
  return (
    <Button
      type="button"
      variant="secondary"
      onClick={onClick}
      disabled={loading || userIsAdminUsersAtMikatanoID}
    >
      一般へ変更
    </Button>
  );
};
